import { IWeapon } from '../../data/types/ship/weapon/weapon';
import { WeaponConfig } from '../../data/types/ship/weapon/weapon-config';
import { weaponConfigs } from './weapon.configs';
import memoize from 'fast-memoize';

export const getWeaponConfig = memoize(
  (weapon: IWeapon): WeaponConfig => weaponConfigs[weapon.type],
);
